import script from "./ProjectClientFilterDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectClientFilterDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectClientFilterDropdown.vue?vue&type=style&index=0&id=0dd6e9fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd6e9fa"]])

export default __exports__